@file:Suppress("ktlint:standard:filename")

package dev.jfronny.zerointerest

import androidx.compose.ui.ExperimentalComposeUiApi
import androidx.compose.ui.window.ComposeViewport
import com.github.terrakok.navigation3.browser.HierarchicalBrowserNavigation
import com.github.terrakok.navigation3.browser.buildBrowserHistoryFragment
import de.connect2x.lognity.api.backend.Backend
import dev.jfronny.zerointerest.ui.App
import dev.jfronny.zerointerest.ui.LoadingScreenExtras
import dev.jfronny.zerointerest.util.KoinLogWrangler
import dev.jfronny.zerointerest.util.LognityWrangler
import dev.jfronny.zerointerest.util.rememberNavigator
import js.string.JsStrings.toKotlinString
import kotlin.js.ExperimentalWasmJsInterop
import kotlin.js.JsModule
import kotlin.js.toJsString
import org.koin.compose.KoinApplication
import org.koin.dsl.koinConfiguration
import org.koin.dsl.module
import web.console.console
import web.history.history
import web.url.URLSearchParams
import web.window.window

@OptIn(ExperimentalWasmJsInterop::class)
@JsModule("@js-joda/timezone")
external object JsJodaTimeZoneModule

private val jsJodaTz = JsJodaTimeZoneModule

@OptIn(ExperimentalComposeUiApi::class, ExperimentalWasmJsInterop::class)
fun main() {
    val params = URLSearchParams(window.location.search)
    operator fun URLSearchParams.get(name: String): String? = get(name.toJsString())?.toKotlinString()

    if (params.size != 0) {
        console.log("Received parameters:")
        params.forEach { value, key ->
            console.log("${key.toKotlinString()}: ${value.toKotlinString()}".toJsString())
        }
        history.pushState(null, "", window.location.pathname) // Clear URL parameters after reading
    }

    Backend.set(LognityWrangler)
    ComposeViewport {
        KoinApplication(
            configuration = koinConfiguration(declaration = {
                logger(KoinLogWrangler)
                modules(
                    createAppModule(),
                    module {
                        single {
                            LoadingScreenExtras(
                                homeserver = params["homeserver"],
                                idpId = params["idpId"],
                                loginToken = params["loginToken"],
                            )
                        }
                    },
                )
            }),
            content = {
                val navHelper = rememberNavigator()

                HierarchicalBrowserNavigation {
                    val g = navHelper.state.rootBackStack.lastOrNull()
                    buildBrowserHistoryFragment(g.toString())
                }

                App(navHelper = navHelper)
            },
        )
    }
}
